import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

class SB3SizeMonitor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sizeMB: null,
      status: 'idle'
    };
    this.intervalId = null;
    this.isRunning = false;
  }

  componentDidMount() {
    this.measureNow();
    this.intervalId = window.setInterval(this.measureNow, 15000);
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  measureNow = async () => {
    const {saveProjectSb3} = this.props;
    if (!saveProjectSb3 || this.isRunning) return;

    this.isRunning = true;

    try {
      const content = await saveProjectSb3();
      const bytes =
        typeof content?.byteLength === 'number'
          ? content.byteLength
          : typeof content?.size === 'number'
          ? content.size
          : 0;

      const sizeMB = bytes / (1024 * 1024);

      this.setState({
        sizeMB,
        status: 'ok'
      });
    } catch (err) {
      console.error('[SB3SizeMonitor] failed to measure size:', err);
      this.setState({status: 'error'});
    } finally {
      this.isRunning = false;
    }
  };

  render() {
    const {sizeMB, status} = this.state;

    if (status === 'error') {
      return (
        <div
          style={{
            marginLeft: '12px',
            padding: '6px 10px',
            borderRadius: '999px',
            background: '#fef2f2',
            border: '1px solid #fecaca',
            color: '#b91c1c',
            fontSize: '0.75rem',
            fontWeight: 600,
            whiteSpace: 'nowrap'
          }}
        >
          SB3 size unavailable
        </div>
      );
    }

    const display = sizeMB === null ? 'Checking...' : `${sizeMB.toFixed(2)} MB`;

    let bg = '#f0fdf4';
    let border = '#bbf7d0';
    let color = '#166534';

    if (sizeMB !== null && sizeMB > 25) {
      bg = '#fef2f2';
      border = '#fecaca';
      color = '#b91c1c';
    } else if (sizeMB !== null && sizeMB > 15) {
      bg = '#fff7ed';
      border = '#fed7aa';
      color = '#c2410c';
    }

    return (
      <div
        title="Best under 15 MB. Hard limit: 25 MB."
        style={{
          marginLeft: '12px',
          padding: '6px 10px',
          borderRadius: '999px',
          background: bg,
          border: `1px solid ${border}`,
          color,
          fontSize: '0.75rem',
          fontWeight: 600,
          whiteSpace: 'nowrap'
        }}
      >
        SB3 size: {display}
      </div>
    );
  }
}

SB3SizeMonitor.propTypes = {
  saveProjectSb3: PropTypes.func
};

const mapStateToProps = state => ({
  saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm)
});

export default connect(mapStateToProps)(SB3SizeMonitor);